module.exports = __webpack_public_path__ + "static/media/rd-logo.d3d0c1ba.png";